var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.imageUrl,"alt":"Card image cap"},on:{"click":_vm.showPhotosModal}}),_vm._v(" "),_c('photos-modal',{ref:"photosModal",attrs:{"photos":_vm.photos,"image-url":_vm.imageUrl,"photo":_vm.imageIndex}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665de688","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/subnavItems/PhotoCard.vue
// module id = null
// module chunks = 